define([
	"dojo/_base/declare",
	"dojo/dom-construct",
	"csi/heading/Renderer",
	"csi/html",
	"csi/page/SearchManager",
	"csi/xml",
	"dojo/text!csi/templates/card.html"
], function(declare,domConstruct,Renderer,html,SearchManager,xml,template) {
	
	return declare(Renderer, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			var node = ctx.getNode();
			var defs = SearchManager.getCardItemDefs(node.$Type, node, xml.path("__FavoriteItem__"));
			var card = html.templateToHtml(ctx, template, defs);
			domConstruct.place(card, refNode);
			return true;
		}
	});
});